import { Store, BookOpenCheck, BellRing } from "lucide-react";

export function HowItWorks() {
  const steps = [
    {
      icon: Store,
      title: "1. Configure sua Loja",
      description:
        "Cadastre sua organização com logo, endereço e informações de contato. Em poucos minutos, seu negócio está pronto para operar online.",
    },
    {
      icon: BookOpenCheck,
      title: "2. Publique seu Catálogo",
      description:
        "Adicione produtos com fotos, organize em seções, defina horários e taxas de entrega. Seu link exclusivo fica pronto para compartilhar e vender.",
    },
    {
      icon: BellRing,
      title: "3. Receba Pedidos e Lucre",
      description:
        "Cada 'plim' é um novo pedido chegando pelo catálogo. Aceite com um clique, gerencie na plataforma e imprima se precisar. Simples assim!",
    },
  ];

  return (
    <section
      id="how-it-works"
      className="py-20 px-4 text-white container mx-auto scroll-mt-20"
    >
      <div className="text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Comece a Vender em{" "}
          <span className="text-black">3 Passos Simples</span>
        </h2>
        <p className="text-white/80 mb-12 text-lg max-w-2xl mx-auto">
          Deixe a complexidade das planilhas para trás e transforme sua operação
          com uma simplicidade que você nunca viu.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {steps.map((step, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 p-8 rounded-xl shadow-md text-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg"
          >
            <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#FFF4E8] border border-[#EE7B11]">
              <step.icon className="w-8 h-8 text-[#EE7B11]" />
            </div>
            <h3 className="text-xl text-black font-semibold mb-3">
              {step.title}
            </h3>
            <p className="text-gray-600">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
